const FeatureTypes = {
  ANSWER_EXPLANATION: 'answerExplanation',
  ADS_FREE: 'adsFree',
  ASYNC_GAME_UNLIMITED: 'longGameExpiry',
  TOPIC_TAGS: 'tagQuestionTopics',
  TAG_STANDARDS: 'tagQuestionStandards',
  REOPEN_GAMES: 'reopenGames',
  AUDIO: 'audio',
  VIDEO: 'video',
  MATCH: 'match',
  REORDER: 'reorder',
  EDIT_PUBLIC_QUIZ: 'editPublicQuiz',
  EDIT_PUBLIC_PRESENTATION: 'editPublicPresentation',
  PRIVATE_CONTENT_QUIZ: 'privateContentQuiz',
  PRIVATE_CONTENT_PRESENTATION: 'privateContentPresentation',
  THEMES: 'themes',
  QBANK: 'qbank',
  PREMIUM_CONTENT: 'premiumContent',
  PREMIUM_RECOMMENDED: 'premiumRecommended',
  FIB_MATCHERS: 'fibMatchers',
  FREE_TRIAL_14: 'freeTrial14',
  LESSON_THEMES: 'lesson_themes',
  LMS_CUSTOM_GRADING: 'lmsCustomGrading',
  IMAGE_SEARCH: 'imageSearch',
  HARD_TIMER: 'hard-timer',
  BRANDING: 'branding',
  INFINITE_GAME_EXPIRY: 'infiniteGameExpiry',
  PLAY_QUIZ: 'playQuiz',
  CAN_SHOW_WORK: 'canShowWork',
  STUDENT_REPORTS: 'studentReport',
  AUDIO_QUESTION: 'audioQuestion',
  VIDEO_QUESTION: 'videoQuestion',
  MATCH_QUESTION: 'matchQuestion',
  REORDER_QUESTION: 'reorderQuestion',
  DRAGNDROP_QUESTION: 'dragNDropQuestion',
  DROPDOWN_QUESTION: 'dropdownQuestion',
  EQUATION_QUESTION: 'equationQuestion',
  HOTSPOT_QUESTION: 'hotspotQuestion',
  CLASSIFICATION_QUESTION: 'classificationQuestion',
  COMPREHENSION_QUESTION: 'comprehensionQuestion',
  DND_IMAGE_QUESTION: 'dndImageQuestion',
  GRAPHING_QUESTION: 'graphingQuestion',
  DISTRICT_LIBRARY: 'districtLibrary',
  GCL: 'gcl',
  FOCUS_MODE: 'focusMode',
  REVIEW_AND_SUBMIT: 'reviewAndSubmit',
  SKIP_QUESTION: 'skipQuestion',
  SCHEDULE_LATER: 'scheduleLater',
  SUPER_QUESTION_SAVE_MODAL: 'super_question_save_modal',
  EDIT_RUNNING_QUESTION: 'edit-running-question',
  EDIT_REPORT_RUNNING_QUESTION: 'editRunningQuestion',
  SHARE_REPORT: 'share-report',
  BULK_ADD_TELEPORT: 'premiumContent-bulkAddTeleport',
  ADD_ARCHIVE_RESOURCE_FROM_TELEPORT: 'premiumContent-addArchiveResourceFromTeleport',
  EDIT_PREMIUM_WEEK_QUIZ: 'edit-premium-week-quiz',
  DRAGNDROP_INTENT: 'dndIntent',
  HOTSPOT_INTENT: 'hotspotIntent',
  HAS_REDEMPTION_PASS: 'hasRedemptionPass',
  MATH_RESPONSE_INTENT: 'mathResponseIntent',
  Q_MEDIA: 'qmedia',
  REDEMPTION: 'redemption',
  EXTRA_LIFE: 'extraLife',
  MASTERY_MODE: 'masteryMode',
  TIMER_3: 'timer_3',
  STUDENT_LEADERBOARD: 'studentLeaderboard',
  SHOW_ANSWERS_2: 'showAnswers_2',
  MYSTIC_PEAK: 'mysticPeak',
  AUTO_CONVERTED_CONTENT: 'auto-converted-content',
  EDIT_ACTIVITY_SETTINGS: 'editRunningGameSetting',
  EVALUATE_QUESTION: 'rescoreQuestionResponses',
  CO_TEACHING_GAME_SETTINGS: 'co-teaching-game-settings',
  PAUSE_GAME: 'pauseLiveGame',
  SEARCH_FILTER_SHARED_LIBRARY: 'search_filter_shared_library',
  COMPREHENSION_ACTIVITY: 'comprehensionActivity',
  ALLOW_CA_GAME_RETAKE_FOR_CLASS: 'retake-ca-game',
};

export default FeatureTypes;
